/* unplugin-vue-components disabled */import script from "./cate-editor-form.vue?vue&type=script&setup=true&lang=js"
export * from "./cate-editor-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__